module.exports = __webpack_public_path__ + "static/media/screenshot@2x.02c3575f.png";